import Enter from './Enter';

const EnterRoute = {
  path: 'enter',
  element: <Enter />,
};

export default EnterRoute;
